<ng-container *ngIf="isKnownAccountable(accountable); else unknownBlock">{{
    "recommendations.actions-detail.table.accountable." + accountable | translate
    }}</ng-container>
<ng-template #unknownBlock>{{ accountable }}</ng-template>
